<app-uni-page
  [parent]="this"
  pageTitle="Job Order Detail - Pull Apply Item Detail"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
>
</app-uni-page>

<ng-template #bodyTemplate>
  <div class="flex h-full w-full flex-col overflow-hidden">
    <div class="shrink-0" style="min-height: 60px; flex: 1">
      <app-ag-grid [gridOptions]="jodGridOptions" [rowData]="joDetails" [hasFooter]="false"></app-ag-grid>
    </div>
    <div class="qb-child-actions shrink-0">
      <span class="font-semibold">Matching Inventory</span>
      <div *ngIf="hasAccountOwnedMatches" class="ml-4 flex items-center">
        <p-checkbox [(ngModel)]="allowNonAccountOwned" inputId="allowNonAccountOwned" [binary]="true"></p-checkbox>
        <label for="allowNonAccountOwned" class="ml-2">Pull non-Account-Owned items?</label>
      </div>
    </div>
    <div class="min-h-0 flex-1">
      <app-ag-grid [gridOptions]="itdMatchGridOptions" [rowData]="matchingItemDetails"></app-ag-grid>
      <ng-template #selectItemDetailCell let-row>
        <button pButton type="button" class="p-button-text p-button-sm" *ngIf="canCheckItemDetail(row)" (click)="selectItemDetail(row)">
          Mark as Scanned
        </button>
      </ng-template>
    </div>
    <div *ngIf="itemDetails != null || errorMessage.length" class="shrink-0">
      <div class="qb-child-actions shrink-0">
        <span class="font-semibold">Scanned Inventory</span>
      </div>
      <div class="mb-2 ml-4 mt-2" *ngIf="itemDetails != null">
        <app-ag-grid [gridOptions]="itdGridOptions" [rowData]="itemDetails" [hasFooter]="false"></app-ag-grid>
      </div>

      <div class="ml-4" [hidden]="itemDetails == null || errorMessage.length">
        <span *ngIf="isStyleSizeMismatch">
          <h5 *ngIf="alternativeAlreadyExists" class="bold">This alternative is already registered. You may proceed.</h5>
          <h5 *ngIf="!alternativeAlreadyExists" class="bold">Product mismatch</h5>
          <div *ngIf="!alternativeAlreadyExists" uni-flex-row>
            <p-checkbox [(ngModel)]="isValidAlternative" inputId="isValidAlternative" [binary]="true"> </p-checkbox>
            <label for="isValidAlternative" class="ml-2">Add this product as an alternative</label>
          </div>
        </span>
      </div>

      <div *ngIf="errorMessage.length">
        <h5 class="ml-4 mt-2">{{ errorMessage }}</h5>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
